import Rollbar from 'rollbar'

const isLocalDevelopment = process.env.NODE_ENV === 'development' && !process.env.IS_STAGING

const rollbar = new Rollbar({
  accessToken: '9f86faa82b81420abbb56933c5abffc2',
  environment: process.env.NODE_ENV || 'development',
  captureUncaught: true,
  captureUnhandledRejections: true,
  enabled: !isLocalDevelopment,
})

export default rollbar
